import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import styles from "./Canal.module.css";
import { Modal } from "react-bootstrap";
import { useState, useEffect } from "react";
import Form from "react-bootstrap/esm/Form";

import prev from "../assets/img/Iconos/arrowPrev.png";

import hbomax from "../assets/img/Cartetelera/big/hbomax_gde.png";
import foxsports from "../assets/img/Cartetelera/big/foxsport_gde.png";
import universal from "../assets/img/Cartetelera/big/universal_gde.png";
import ifizzionados from "../assets/img/Cartetelera/big/afizzionados_gde.png";

import {
  builtSolicitudDeServicio,
  SolicitudDeServicio,
  builtContratacionServicios,
  ContratacionServicios,
  AltaSolicitudDeServicio_Entrada,
  builtAltaSolicitudDeServicio_Entrada,
  AltaSolicitudDeServicio_Parametros,
  AltaSolicitudDeServicio_Respuesta,
  CambioFormaPago,
  builtCambioFormaPago,
  DatosFiscales,
  builtDatosFiscales,
  Direccion,
  builtDireccion,
  CompraControlRemoto,
  builtCompraControlRemoto,
  ActivaRemoteBooking,
  builtActivaRemoteBooking,
  InfoPPE,
  builtInfoPPE,
  Pagos,
  builtPagos,
  DatosTDC,
  builtDatosTDC,
  RespuestaACI,
  builtRespuestaACI,
} from "../Commons/Services/AltaSolicitudDeServicioRest";
import { ConsultaWS } from "../Commons/ServiciosBase";
import Loading from "../General/Loading";
import {
  Product,
  builtProduct,
  ListOfProducts,
  builtListOfProducts,
  Instance,
  builtInstance,
  ListOfInstances,
  builtListOfInstances,
  ServiceInfoRequest,
  builtServiceInfoRequest,
  GestionarSSComprarServiciosRequestEBM,
  builtGestionarSSComprarServiciosRequestEBM,
  GestionarSSComprarServicios_Entrada,
  builtGestionarSSComprarServicios_Entrada,
  GestionarSSComprarServicios_Parametros,
  GestionarSSComprarServicios_Respuesta,
} from "../Commons/Services/GestionarSSComprarServiciosRest";
import ConfirmMessage from "../General/ConfirmMessage";
import {
  ConsultarProducto_Respuesta,
  ConsultarProducto_Entrada,
  builtConsultarProductoEntrada,
  ConsultarProducto_Parametros,
} from "../Commons/Services/ConsultarProducto";

import { Tarjeta } from "../Commons/Services/ConsultarIRD";

import disneyplusnuevo from "../assets/img/Cartetelera/big/disneyplusnuevoimagecanal.png";
import disneyplus_max from "../assets/img/Cartetelera/big/ott-destacados-disney.png";
import starplus_max from "../assets/img/Cartetelera/big/ott-destacados-star.png";
import comboplus_max from "../assets/img/Cartetelera/big/ott-destacados-combo.png";
import vix from "../assets/img/Cartetelera/big/vix.png";
import golden from "../assets/img/Cartetelera/big/Goldenpremiere.png";

import vextremo from "../assets/img/Cartetelera/big/vextremohd_gde.png";
import vextremohd from "../assets/img/Cartetelera/big/vextremohd_gde.png";
import tvhot from "../assets/img/Cartetelera/big/tvhot_gde.png";
import tvhothd from "../assets/img/Cartetelera/big/tvhothd_gde.png";
import secrets from "../assets/img/Cartetelera/big/secrets_gde.png";
import secretshd from "../assets/img/Cartetelera/big/secretshd_gde.png";
import hustler from "../assets/img/Cartetelera/big/hustler_gde.png";
import hustlerhd from "../assets/img/Cartetelera/big/hustlerhd_gde.png";
import {
  ConsultaCuenta_Respuesta,
  InstanceComponent,
  ServiceInstance,
} from "../Commons/Services/ConsultaCuentaRest";
const Canal = (props: any) => {
  const {
    titulo1,
    imagen1,
    imagenSmall1,
    leyenda1,
    precio1,
    descripcion1,
    muestra1,
    canal1,
    categoria1,
    nombrecrm1,
    consultaCuentaRespuesta1,
  }: any = { ...props };

  const [showModalTerminosCondiciones, setShowModalTerminosCondiciones] =
    useState(false);
  const [
    showModalTerminosCondicionesDisney,
    setShowModalTerminosCondicionesDisney,
  ] = useState(false);
  const [showModalQuieresContratar, setShowModalQuieresContratar] =
    useState(false);
  const [tarjetas, setTarjetas] = useState<any[]>([]);
  const [seleccionTarjeta, setSeleccionTarjeta] = useState("");
  const [seleccionIRD, setSeleccionIRD] = useState("");
  const [loading, isLoading] = useState(false);

  const [PrecioFinal, setPrecioFinal] = useState("0");

  const [status1, setStatus1] = useState("OK");
  const [message1, setMessage1] = useState("");
  const [showAlert1, setShowAlert1] = useState(false);

  const [acceptedOttTerms, setAcceptedOttTerms] = useState<boolean>(false);
  const tipoPlan = sessionStorage.getItem("tipoCliente");

  const handleAcceptedDisneyTerms = () => {
    setAcceptedOttTerms(!acceptedOttTerms);
  };

  //modal 1
  const handleShowModalTerminosCondiciones = () =>
    setShowModalTerminosCondiciones(true);
  const handleCloseModalTerminosCondiciones = () =>
    setShowModalTerminosCondiciones(false);
  //modal 2
  const handleShowModalTerminosCondicionesDisney = () =>
    setShowModalTerminosCondicionesDisney(true);
  const handleCloseModalTerminosCondicionesDisney = () =>
    setShowModalTerminosCondicionesDisney(false);

  //modal2
  const handleShowModalQuieresContratar = () =>
    setShowModalQuieresContratar(true);
  const handleCloseModalQuieresContratar = () =>
    setShowModalQuieresContratar(false);

  const obtieneTarjeta = (e: any) => {
    var cardSelected = e.target.value;
    var arraycardIntelligent = cardSelected.split("+");
    setSeleccionTarjeta(arraycardIntelligent[0]);
    setSeleccionIRD(arraycardIntelligent[1]);
  };

  const verificaskyplus = sessionStorage.getItem("PaqueteSky+");
  let preciovix = "";

  if (verificaskyplus != undefined && verificaskyplus == "SKY+ Premium") {
    preciovix = "79";
  } else if (verificaskyplus != undefined && verificaskyplus == "SKY+ Basico") {
    preciovix = "99";
  } else {
    preciovix = "99";
  }

  const precios = [
    { titulo: "Max", leyenda: "", precio: "199" },
    sessionStorage.getItem("tipoCliente") === "POS"
      ? { titulo: "Universal+", leyenda: "", precio: "159" }
      : { titulo: "Universal+", leyenda: "", precio: "179" },
    { titulo: "Fox Sports Premium", leyenda: "", precio: "139" },

    {
      titulo: "ViX Premium",
      leyenda: "Por tiempo limitado",
      precio: preciovix,
    },
  ];

  const getServiceFamilyFlag = (
    p_ConsultaCuentaRespuesta: ConsultaCuenta_Respuesta,
    p_nombreservicio: string
  ) => {
    let retorno = false;

    let InstanceComponentArray: InstanceComponent[] =
      p_ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount.Account[0].ListOfServiceInstance?.ServiceInstance.find(
        (x: ServiceInstance) =>
          x.ServiceProductType === "VIDEO" &&
          x.SlaveHierarchy === "Master" &&
          x.StatusCode === "Activo"
      )?.ListOfInstanceComponent?.InstanceComponent!;

    InstanceComponentArray.map(
      (instanceComponent: InstanceComponent, index: number) => {
        let nombreProducto = instanceComponent.Product;

        if (
          nombreProducto.toLowerCase().includes(p_nombreservicio.toLowerCase())
        ) {
          retorno = true;
        }
      }
    );

    return retorno;
  };

  useEffect(() => {
    let tarjetas: any = "";
    if (sessionStorage.getItem("tarjetas") !== null) {
      tarjetas = sessionStorage.getItem("tarjetas");
    }
    if (tarjetas !== "") {
      let arTarjetas = JSON.parse(tarjetas);
      let arTarjetasTemp: any[] = [];
      arTarjetas.forEach((element: any) => {
        if (
          element.Categoria !== "SKY IPC UHD" ||
          element.Categoria !== "SKY HMC EHD"
        ) {
          arTarjetasTemp.push(element);
        }
      });
      setTarjetas(arTarjetasTemp);
    }
  }, []);

  const getImages = (titulo: string, source: string) => {
    if (titulo.includes("izzi") || titulo.includes("IZZI")) {
      return ifizzionados;
    } else if (
      titulo.includes("HBO") ||
      (titulo.includes("hbo") && titulo.includes("MAX")) ||
      titulo.includes("Max")
    ) {
      return hbomax;
    } else if (titulo.includes("fox sports") || titulo.includes("Fox Sports")) {
      return foxsports;
    } else if (titulo.includes("universal") || titulo.includes("Universal")) {
      return universal;
    } else if (
      titulo.toLowerCase().includes("disney+ estandar") ||
      titulo.toLowerCase().includes("disney+ premium")
    ) {
      return disneyplusnuevo;
    } else if (titulo.includes("disney") || titulo.includes("Disney")) {
      return disneyplus_max;
    } else if (titulo.includes("star") || titulo.includes("Star")) {
      return starplus_max;
    } else if (titulo.includes("combo") || titulo.includes("Combo")) {
      return comboplus_max;
    } else if (titulo.toLocaleLowerCase().includes("vix")) {
      return vix;
    } else if (
      titulo.includes("golden Premiere") ||
      titulo.includes("Golden")
    ) {
      return golden;
    } else if (titulo.toLocaleLowerCase().includes("vextremo")) {
      if (titulo.toLocaleLowerCase().includes("hd")) {
        return vextremohd;
      } else {
        return vextremo;
      }
    } else if (
      titulo.toLocaleLowerCase().includes("tvhot") ||
      titulo.toLocaleLowerCase().includes("tv hot")
    ) {
      if (titulo.toLocaleLowerCase().includes("hd")) {
        return tvhothd;
      } else {
        return tvhot;
      }
    } else if (titulo.toLocaleLowerCase().includes("secrets")) {
      if (titulo.toLocaleLowerCase().includes("hd")) {
        return secretshd;
      } else {
        return secrets;
      }
    } else if (titulo.toLocaleLowerCase().includes("hustler")) {
      if (titulo.toLocaleLowerCase().includes("hd")) {
        return hustlerhd;
      } else {
        return hustler;
      }
    } else {
      return source;
    }
  };

  const getStyle = (titulo: string) => {
    if (
      titulo.includes("HBO") ||
      (titulo.includes("hbo") && titulo.includes("MAX")) ||
      titulo.includes("max")
    ) {
      return "imagen";
    } else if (titulo.includes("fox sports") || titulo.includes("Fox Sports")) {
      return "imagen";
    } else if (titulo.includes("universal") || titulo.includes("Universal")) {
      return "imagen";
    } else {
      return "imagenNoContemplada";
    }
  };

  const getFinalePrice = () => {
    let promo = false;
    for (let i = 0; i < precios.length; i++) {
      let item = precios[i];

      if (item.titulo === titulo1) {
        promo = true;

        return item.precio;
      } else {
        promo = false;
      }
    }

    if (!promo) {
      return precio1;
    }
  };

  const doContratarCanal = async () => {
    let nuevoPrecio = getFinalePrice();

    if (
      categoria1 &&
      categoria1 != null &&
      categoria1 != "" &&
      canal1 &&
      canal1 != null &&
      canal1 != ""
    ) {
      doAltaSolicitudDeServicio(titulo1, nuevoPrecio, canal1);
    } else {
      //Streaming

      doGestionarSSComprarServicios(titulo1);
    }
  };

  const doGestionarSSComprarServicios = async (p_titulo2: string) => {
    //----------------------------------------------------------------------------------------------------------------------------
    let tarjetaMaster: Tarjeta = {
      TarjetaInteligente: "",
      IRD: "",
      Ubicacion: "",
      Status: "",
      Jerarquia: "",
      Categoria: "",
      Flg_funcionalidad: "",
    };
    if (sessionStorage.getItem("tarjetaMaster") !== null) {
      tarjetaMaster = JSON.parse(sessionStorage.getItem("tarjetaMaster")!);
    }

    isLoading(true);

    let product1: Product = builtProduct("", "Add");
    let product2: Product = builtProduct("", "Add");
    let listOfProducts: ListOfProducts = builtListOfProducts([]);

    if (nombrecrm1.toLocaleLowerCase().includes("combo+")) {
      if (getServiceFamilyFlag(consultaCuentaRespuesta1, "Disney+")) {
        product1 = builtProduct(nombrecrm1, "Add");
        product2 = builtProduct("Servicio Disney+", "Disconnect");
        listOfProducts = builtListOfProducts([product1, product2]);
      } else if (getServiceFamilyFlag(consultaCuentaRespuesta1, "Star+")) {
        product1 = builtProduct(nombrecrm1, "Add");
        product2 = builtProduct("Servicio OTT Star+", "Disconnect");
        listOfProducts = builtListOfProducts([product1, product2]);
      }
    } else {
      product1 = builtProduct(nombrecrm1, "Add");
      listOfProducts = builtListOfProducts([product1]);
    }

    if (nombrecrm1.toLocaleLowerCase().includes("disney+ premium")) {
      if (getServiceFamilyFlag(consultaCuentaRespuesta1, "Disney+ Estandar")) {
        product1 = builtProduct(nombrecrm1, "Add");
        product2 = builtProduct(
          "Servicio OTT Disney+ Estandar DTH",
          "Disconnect"
        );
        listOfProducts = builtListOfProducts([product1, product2]);
      }
    }

    const instance: Instance = builtInstance(
      tarjetaMaster.TarjetaInteligente,
      tarjetaMaster.IRD!,
      listOfProducts
    );
    const listOfInstances: ListOfInstances = builtListOfInstances([instance]);
    const serviceInfoRequest: ServiceInfoRequest = builtServiceInfoRequest(
      "Servicio Adicional",
      `${sessionStorage.getItem("cuenta")}`,
      "Service OTT",
      "Venta a suscriptor",
      "Solicitud de Aprovisionamiento",
      "Web",
      listOfInstances
    );

    const gestionarSSComprarServiciosRequestEBM: GestionarSSComprarServiciosRequestEBM =
      builtGestionarSSComprarServiciosRequestEBM(serviceInfoRequest);
    const gestionarSSComprarServiciosEntrada: GestionarSSComprarServicios_Entrada =
      builtGestionarSSComprarServicios_Entrada(
        gestionarSSComprarServiciosRequestEBM
      );

    let GestionarSSComprarServiciosParametros =
      GestionarSSComprarServicios_Parametros(
        gestionarSSComprarServiciosEntrada
      );

    let GestionarSSComprarServiciosRespuesta: GestionarSSComprarServicios_Respuesta =
      await ConsultaWS(GestionarSSComprarServiciosParametros);
    //----------------------------------------------------------------------------------------------------------------------------

    if (
      GestionarSSComprarServiciosRespuesta
        .GestionarSSComprarServiciosResponseEBM.ServiceInfoResponse.NumeroSS &&
      GestionarSSComprarServiciosRespuesta
        .GestionarSSComprarServiciosResponseEBM.ServiceInfoResponse.NumeroSS !=
        null &&
      GestionarSSComprarServiciosRespuesta
        .GestionarSSComprarServiciosResponseEBM.ServiceInfoResponse.NumeroSS !=
        ""
    ) {
      setStatus1("OK");
      setMessage1(
        "Servicio contrato exitosamente " +
          GestionarSSComprarServiciosRespuesta
            .GestionarSSComprarServiciosResponseEBM.ServiceInfoResponse.NumeroSS
      );
      setShowAlert1(true);
      setTimeout(() => {
        setShowAlert1(false);
        setSeleccionTarjeta("0");
        muestra1(true);
      }, 3000);
    } else {
      console.error(GestionarSSComprarServiciosRespuesta);
      setStatus1("ERROR");
      setMessage1(
        "No puede contratar "
          .concat(p_titulo2)
          .concat(" por favor llame a atención a clientes.")
      );
      //setMessage1(GestionarSSComprarServiciosRespuesta.EBMHeaderResponse.ErrorNegocio.DescripcionError);
      setShowAlert1(true);
      setTimeout(() => {
        setShowAlert1(false);

        setSeleccionTarjeta("0");
        muestra1(true);
      }, 3000);
    }

    isLoading(false);
  };

  const doAltaSolicitudDeServicio = async (
    p_titulo2: string,
    p_precio2: string,
    p_canal2: string
  ) => {
    //----------------------------------------------------------------------------------------------------------------------------
    isLoading(true);
    const cambioFormaPago: CambioFormaPago = builtCambioFormaPago(
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      ""
    );
    const datosFiscales: DatosFiscales = builtDatosFiscales("", "", "", "", "");
    const direccion: Direccion = builtDireccion("", "", "", "", "", "", "", "");

    const contratacionServicios: ContratacionServicios =
      builtContratacionServicios(
        `${sessionStorage.getItem("Paquete")}`,
        getNamesForSendToWSPREPOST(p_titulo2)!,
        getNamesForSendToWSPREPOST(p_titulo2)!,
        p_canal2, //l_NoCanalALaCarta: string,
        p_precio2,
        "N" //l_PenalizacionVETVCA: string
      );

    const compraControlRemoto: CompraControlRemoto = builtCompraControlRemoto(
      "",
      "",
      "",
      "",
      ""
    );

    const activaRemoteBooking: ActivaRemoteBooking = builtActivaRemoteBooking(
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      ""
    );

    const infoPPE: InfoPPE = builtInfoPPE(
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      ""
    );

    const datosTDC: DatosTDC = builtDatosTDC("", "", "", "", "", "");

    const respuestaACI: RespuestaACI = builtRespuestaACI(
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      ""
    );

    const pagos: Pagos = builtPagos("", "", "", datosTDC, respuestaACI);

    const solicitudDeServicio: SolicitudDeServicio = builtSolicitudDeServicio(
      `${sessionStorage.getItem("cuenta")}`,
      "Web",
      "Canales a la Carta",
      "SEL - " + getNamesForSendToWSPREPOST(p_titulo2),
      seleccionTarjeta,
      `${sessionStorage.getItem("RowIdContacto")}`,
      `${sessionStorage.getItem("EmailNotif")}`,
      `${sessionStorage.getItem("pais")}`,
      `${sessionStorage.getItem("Producto")}`, //`${sessionStorage.getItem("TipoCuenta")}`,
      `${sessionStorage.getItem("NombreSuscriptor")}`,
      datosFiscales,
      direccion,
      contratacionServicios,
      compraControlRemoto,
      activaRemoteBooking,
      infoPPE,
      pagos,
      cambioFormaPago,
      "HIJUMP",
      `${sessionStorage.getItem("idSesion")}`
    );
    const AltaSolicitudDeServicioEntrada: AltaSolicitudDeServicio_Entrada =
      builtAltaSolicitudDeServicio_Entrada(solicitudDeServicio);
    let AltaSolicitudDeServicioParametros = AltaSolicitudDeServicio_Parametros(
      AltaSolicitudDeServicioEntrada
    );

    let AltaSolicitudDeServicioRespuesta: AltaSolicitudDeServicio_Respuesta =
      await ConsultaWS(AltaSolicitudDeServicioParametros);

    if (
      AltaSolicitudDeServicioRespuesta.NumeroSolicitud &&
      AltaSolicitudDeServicioRespuesta.NumeroSolicitud != null &&
      AltaSolicitudDeServicioRespuesta.NumeroSolicitud !== ""
    ) {
      setStatus1("OK");
      setMessage1(
        "Servicio contrato exitosamente " +
          AltaSolicitudDeServicioRespuesta.NumeroSolicitud
      );
      setShowAlert1(true);
      setTimeout(() => {
        setShowAlert1(false);
        setSeleccionTarjeta("0");
        muestra1(true);
      }, 3000);
    } else {
      console.error(AltaSolicitudDeServicioRespuesta);
      setStatus1("ERROR");
      setMessage1(AltaSolicitudDeServicioRespuesta.resultadodesc);
      setShowAlert1(true);
      setTimeout(() => {
        setShowAlert1(false);
        setSeleccionTarjeta("0");
        muestra1(true);
      }, 3000);
    }
    isLoading(false);
    //----------------------------------------------------------------------------------------------------------------------------
  };

  const validateCreditCard = () => {
    if (
      seleccionTarjeta &&
      seleccionTarjeta !== null &&
      seleccionTarjeta !== "" &&
      seleccionTarjeta !== "0"
    ) {
      return true;
    } else {
      // Agregar logica Disney y Vix
      console.log(sessionStorage.getItem("assetNumberVideo"));
      console.log(sessionStorage.getItem("SecondAssetNumberVideo"));

      if (
        (titulo1 as string).toLowerCase().includes("disney+") ||
        (titulo1 as string).toLowerCase().includes("vix")
      ) {
        if (
          sessionStorage.getItem("assetNumberVideo") !== undefined &&
          sessionStorage.getItem("assetNumberVideo") !== null &&
          sessionStorage.getItem("SecondAssetNumberVideo") !== undefined &&
          sessionStorage.getItem("SecondAssetNumberVideo") !== null
        ) {
          setSeleccionTarjeta(sessionStorage.getItem("assetNumberVideo")!);
          setSeleccionIRD(sessionStorage.getItem("SecondAssetNumberVideo")!);
          return true;
        }
      }

      return false;
    }
  };

  const doValidateEnoughCredit = () => {
    let saldoCuentaConsultado: number =
      sessionStorage.getItem("saldo") !== ""
        ? Number(sessionStorage.getItem("saldo"))
        : 0;

    if (saldoCuentaConsultado < 0) {
      //La cuenta tiene saldo a favor
      const saldoAfavor = saldoCuentaConsultado * -1;
      if (saldoAfavor < precio1) {
        //El saldo a favor de la cuenta no cubre totalmente el precio del PPE
        //Se manda a pagar la diferencia con TC
        const totalDiferenciaPorPagar = precio1 - saldoAfavor;
        setStatus1("ERROR");
        setMessage1(
          `Se tendra que pagar con tarjeta la siguiente diferencia: ${totalDiferenciaPorPagar}`
        );
        setShowAlert1(true);
        setTimeout(() => {
          setShowAlert1(false);
        }, 5000);
        //alert(`Se tendra que pagar con tarjeta la siguiente diferencia: ${totalDiferenciaPorPagar}`);
        return false;
      } else {
        return true;
      }
    } else {
      //La cuenta no tiene saldo a favor, se manda a pagar con TC el PPE con el saldo + precio
      //respuesta.totalPorPagar = saldoCuentaConsultado + precio;
      setStatus1("ERROR");
      setMessage1(
        `Se tendra que pagar con tarjeta la siguiente diferencia: ${
          saldoCuentaConsultado + precio1
        }`
      );
      setShowAlert1(true);
      setTimeout(() => {
        setShowAlert1(false);
      }, 5000);
      return false;
    }
  };

  const getNamesForSendToWSPREPOST = (p_name: string) => {
    if (sessionStorage.getItem("tipoCliente") === "POS") {
      if (titulo1.includes("Golden")) {
        return "Golden Premiere HD";
      }

      if (titulo1.includes("Max")) {
        return "HBO/MAX A la Carta";
      }

      if (titulo1.includes("Universal")) {
        return "Universal+ MX";
      }
      if (titulo1.includes("Fox")) {
        return "Fox Sports Pospago";
      }
    } else {
      if (titulo1.includes("Golden")) {
        return "Golden Premiere prepago HD";
      }

      if (titulo1.includes("Max")) {
        return "HBO/MAX A la Carta Prep HD";
      }

      if (titulo1.includes("Universal")) {
        return "Universal+ MX prepago HD";
      }
      if (titulo1.includes("Fox")) {
        return "Fox Sports Prepago";
      }
    }
  };

  const doConsultarProducto = async () => {
    //var retorno = false;
    //----------------------------------------------------------------------------------------------------------------------------
    const ConsultarProductoEntrada: ConsultarProducto_Entrada =
      builtConsultarProductoEntrada(
        sessionStorage.getItem("cuenta")!,
        getNamesForSendToWSPREPOST(titulo1)!,
        seleccionTarjeta
      );
    let ConsultarProductoParametros = ConsultarProducto_Parametros(
      ConsultarProductoEntrada
    );

    let ConsultarProductoRespuesta: ConsultarProducto_Respuesta =
      await ConsultaWS(ConsultarProductoParametros);

    if (
      ConsultarProductoRespuesta.ProductoContratado &&
      ConsultarProductoRespuesta.ProductoContratado !== "" &&
      ConsultarProductoRespuesta.ProductoContratado !== null
    ) {
      if (ConsultarProductoRespuesta.ProductoContratado === "N") {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  //----------------------------------------------------------------------------------------------------------------------------

  const doValidaciones = async () => {
    //SE VALIDA SELECCION DE TARJETA INTELIGENTE
    if (validateCreditCard()) {
      if (
        categoria1 &&
        categoria1 !== null &&
        categoria1 !== "" &&
        canal1 &&
        canal1 !== null &&
        canal1 !== ""
      ) {
        //PELICULAS;DEPORTES;ADULTOS
        doConsultarProducto().then((respuesta: boolean) => {
          if (respuesta) {
            if (sessionStorage.getItem("tipoCliente") === "PRE") {
              if (doValidateEnoughCredit()) {
                if (
                  (titulo1 as string).toLowerCase().includes("disney+") ||
                  (titulo1 as string).toLowerCase().includes("vix") ||
                  (titulo1 as string).toLowerCase().includes("max") ||
                  (titulo1 as string).toLowerCase().includes("universal")
                ) {
                  // handleShowModalTerminosCondicionesDisney();
                  if (acceptedOttTerms) {
                    handleShowModalQuieresContratar();
                  } else {
                    console.error("Debes aceptar los términos y condiciones");
                    setStatus1("ERROR");
                    setMessage1("Debes aceptar los términos y condiciones");
                    setShowAlert1(true);
                    setTimeout(() => {
                      setShowAlert1(false);
                    }, 3000);
                  }
                } else {
                  handleShowModalTerminosCondiciones();
                }
              }
            } else {
              if (
                (titulo1 as string).toLowerCase().includes("disney+") ||
                (titulo1 as string).toLowerCase().includes("vix") ||
                (titulo1 as string).toLowerCase().includes("max") ||
                (titulo1 as string).toLowerCase().includes("universal")
              ) {
                // handleShowModalTerminosCondicionesDisney();
                if (acceptedOttTerms) {
                  handleShowModalQuieresContratar();
                } else {
                  console.error("Debes aceptar los términos y condiciones");
                  setStatus1("ERROR");
                  setMessage1("Debes aceptar los términos y condiciones");
                  setShowAlert1(true);
                  setTimeout(() => {
                    setShowAlert1(false);
                  }, 3000);
                }
              } else {
                handleShowModalTerminosCondiciones();
              }
            }
          } else {
            console.error("Este título ya está contratado para esta cuenta");
            setStatus1("ERROR");
            setMessage1("Este título ya está contratado para esta cuenta");
            setShowAlert1(true);
            setTimeout(() => {
              setShowAlert1(false);
            }, 3000);
            //alert();
          }
        });
      } else {
        //STREAMING
        //SE VALIDA SI LA TRAJETA TIENE DERECHO AL STREAMING
        //SI TIENE MAS DE 1 TARJETA Y SELECCIONA UNA QUE NO TENGA
        doConsultarProducto().then((respuesta: boolean) => {
          if (respuesta) {
            if (sessionStorage.getItem("tipoCliente") === "PRE") {
              if (doValidateEnoughCredit()) {
                if (
                  (titulo1 as string).toLowerCase().includes("disney+") ||
                  (titulo1 as string).toLowerCase().includes("vix") ||
                  (titulo1 as string).toLowerCase().includes("max") ||
                  (titulo1 as string).toLowerCase().includes("universal")
                ) {
                  // handleShowModalTerminosCondicionesDisney();
                  if (acceptedOttTerms) {
                    handleShowModalQuieresContratar();
                  } else {
                    console.error("Debes aceptar los términos y condiciones");
                    setStatus1("ERROR");
                    setMessage1("Debes aceptar los términos y condiciones");
                    setShowAlert1(true);
                    setTimeout(() => {
                      setShowAlert1(false);
                    }, 3000);
                  }
                } else {
                  handleShowModalTerminosCondiciones();
                }
              }
            } else {
              if (
                (titulo1 as string).toLowerCase().includes("disney+") ||
                (titulo1 as string).toLowerCase().includes("vix") ||
                (titulo1 as string).toLowerCase().includes("max") ||
                (titulo1 as string).toLowerCase().includes("universal")
              ) {
                // handleShowModalTerminosCondicionesDisney();
                if (acceptedOttTerms) {
                  handleShowModalQuieresContratar();
                } else {
                  console.error("Debes aceptar los términos y condiciones");
                  setStatus1("ERROR");
                  setMessage1("Debes aceptar los términos y condiciones");
                  setShowAlert1(true);
                  setTimeout(() => {
                    setShowAlert1(false);
                  }, 3000);
                }
              } else {
                handleShowModalTerminosCondiciones();
              }
            }
          } else {
            console.error("Este título ya está contratado para esta cuenta");
            setStatus1("ERROR");
            setMessage1("Este título ya está contratado para esta cuenta");
            setShowAlert1(true);
            setTimeout(() => {
              setShowAlert1(false);
            }, 3000);
            //alert();
          }
        });
      }
      //SE VALIDA SI LA PELICULA YA ESTA CONTRATADA
    } else {
      console.error("Favor de seleccionar una Tarjeta Inteligente");
      setStatus1("ERROR");
      setMessage1("Favor de seleccionar una Tarjeta Inteligente");
      setShowAlert1(true);
      setTimeout(() => {
        setShowAlert1(false);
      }, 3000);
      //alert("");
    }
  };

  const handleDescriptionDots = (p_description: string) => {
    let td = [];
    var splitted = p_description.split(".");
    for (let i = 0; i < splitted.length; i++) {
      if (splitted[i].includes("Audio Stereo 5")) {
        td.push(
          <>
            <li key={i}>{splitted[i] + "." + splitted[i + 1]}</li>
          </>
        );
        i++;
      } else {
        td.push(
          <>
            <li key={i}>{splitted[i]}</li>
          </>
        );
      }
    }

    return td;
  };

  return (
    <>
      <div id="big" className="d-none d-xl-block d-lg-block ">
        <ConfirmMessage
          status={status1}
          message={message1}
          showAlert={showAlert1}
        />
        <Loading isLoading={loading} />
        <Container className={styles.contenedor} fluid>
          <Row className={styles["headerRow"]}>
            <Col className={styles["columnaCar"]}>
              <a
                onClick={() => {
                  muestra1(true);
                }}
                className={styles["flecha"]}
              >
                {" "}
                <img src={prev} style={{ width: ".5vw" }} />
              </a>
              <span className={styles["spectrum"]}>Aplicaciones</span>
            </Col>
          </Row>
          <Row>
            <Col>
              <p className={styles["title"]}>
                Disfruta de las opciones que tenemos para ti con cargo extra.
              </p>
            </Col>
          </Row>
        </Container>

        <Container className={styles.contenedor} fluid>
          <Row>
            <Col lg={6} xl={6}>
              <Row>
                <Col lg={6} xl={6}>
                  <span className={styles["tituloazul"]}>{titulo1}</span>
                </Col>
                <Col lg={6} xl={6} className={styles["alignPrice"]}>
                  <Row>
                    {(() => {
                      let td = [];
                      let promo = false;

                      for (let i = 0; i < precios.length; i++) {
                        let item = precios[i];

                        if (tipoPlan === "POS") {
                          if (item.titulo === titulo1) {
                            promo = true;
                            td.push(
                              <>
                                <div className={styles.tituloazul2cross}>
                                  ${precio1} / mes
                                </div>
                                <div>
                                  <span className={styles.tituloazul2}>
                                    ${item.precio}
                                  </span>
                                  <span className={styles.tituloazul3}>
                                    /mes
                                  </span>
                                </div>
                              </>
                            );
                            return td;
                          }
                        } else {
                          if (item.titulo === titulo1) {
                            promo = true;

                            // Obtiene el precio del array de precios
                            let precioFinal = item.precio;

                            td.push(
                              <>
                                <div>
                                  <span className={styles.tituloazul2}>
                                    {
                                      item.titulo === "Universal+"
                                        ? `$${precioFinal}` // ✅ Universal+ obtiene su precio de precios[]
                                        : `$${precioFinal}` // ✅ Todos los demás canales obtienen su precio normal
                                    }
                                  </span>
                                  <span className={styles.tituloazul3}>
                                    /mes
                                  </span>
                                </div>
                              </>
                            );
                            return td;
                          }
                        }
                      }

                      // ✅ Esta parte se ejecutará si ningún canal hace match
                      if (!promo) {
                        td.push(
                          <>
                            <div>
                              <span className={styles.tituloazul2}>
                                ${precio1}
                              </span>
                              <span className={styles.tituloazul3}>/mes</span>
                            </div>
                          </>
                        );
                      }

                      return td;
                    })()}
                  </Row>
                </Col>
              </Row>
              <Row className={styles["texto"] + " pt-4"}>
                <ul>{handleDescriptionDots(descripcion1)}</ul>
              </Row>
            </Col>
            <Col lg={6} xl={6}>
              <div className={styles["centrar"]}>
                <img
                  src={getImages(titulo1, imagen1)}
                  className={styles[getStyle(titulo1)]}
                />
              </div>
            </Col>
          </Row>

          {(titulo1 as string).toLowerCase().includes("disney+") ||
          (titulo1 as string).toLowerCase().includes("vix") ? null : (
            <>
              <Row>
                <Col className={styles["tituloMargin"]}>
                  <span className={styles["tituloazul"]}>Selecciona tu TV</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <p className={styles["title"]}>
                    Elige el equipo en el que desfrutarás de los canales
                    seleccionados
                  </p>
                </Col>
              </Row>
              {tarjetas != null && tarjetas.length > 0 ? (
                <Row>
                  <Col>
                    <Form.Label>Tarjeta inteligente</Form.Label>
                    <Form.Select
                      aria-label="Default select example"
                      className={styles.select}
                      onChange={obtieneTarjeta}
                    >
                      <option value="0">Selecciona tarjeta</option>
                      {tarjetas.map((tarjeta: any, index: number) => {
                        return (
                          <option
                            key={index}
                            value={`${tarjeta.TarjetaInteligente}+${tarjeta.IRD}`}
                          >
                            {tarjeta.TarjetaInteligente}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Col>
                </Row>
              ) : (
                <p>No Hay Tarjetas Inteligentes para Mostrar</p>
              )}
            </>
          )}

          {((titulo1 as string).toLowerCase().includes("disney+") ||
            (titulo1 as string).toLowerCase().includes("vix") ||
            (titulo1 as string).toLowerCase().includes("max") ||
            (titulo1 as string).toLowerCase().includes("universal")) && (
            <Row style={{ marginBlock: "1rem" }}>
              <Col style={{}}>
                <Form style={{ maxWidth: "fit-content", marginInline: "auto" }}>
                  <Form.Check // prettier-ignore
                    type="switch"
                    id="Check Terminos y Condiciones"
                    label={
                      <a
                        className={styles["linkText"]}
                        href="https://sky.com.mx/terminos"
                        target="_blank"
                        rel="noreferrer"
                      >
                        He leído y acepto los{" "}
                        <span
                          className={styles["linkFont"]}
                          style={{ textAlign: "center" }}
                        >
                          Términos y condiciones
                        </span>
                      </a>
                    }
                    onChange={handleAcceptedDisneyTerms}
                  />
                </Form>
              </Col>
            </Row>
          )}

          <Row style={{ marginBlock: "1rem" }}>
            <Col>
              <div className={styles["centrar"]}>
                <Button
                  variant="primary"
                  className={styles["botonazul"]}
                  onClick={() => {
                    doValidaciones();
                    //
                  }}
                >
                  Contratar
                </Button>
                {"  "}
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/***************************
      Inicia seccion responsiva
      *****************************/}

      <div id="small" className="d-lg-none d-xl-none">
        <Container className={styles.contenedorSmall}>
          <Row>
            <Col className={styles["titleContainer"]}>
              <span className={styles["spectrum"]}>Aplicaciones</span>
              <p className={styles["title"]}>
                Disfruta de las opciones que tenemos para ti con cargo extra.
              </p>
            </Col>
          </Row>
          <Row className={styles["imgContainer"]}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img
                src={getImages(titulo1, imagenSmall1)}
                className={styles["imagenSmall"]}
              />
            </div>
          </Row>
        </Container>

        <Container className={styles.contenedorSmall}>
          <Row className={styles["titleContainer"]}>
            <Col style={{ paddingLeft: "4vw" }}>
              <p className={styles["tituloazulSmall"]}>{titulo1}</p>
            </Col>
            <Col className={styles["precio_mesSmall"]}>
              {(() => {
                let td = [];
                let promo = false;
                for (let i = 0; i < precios.length; i++) {
                  let item = precios[i];

                  if (item.titulo === titulo1) {
                    promo = true;
                    td.push(
                      <>
                        <div className={styles.tituloazul2cross}>
                          ${precio1} / mes
                        </div>
                      </>
                    );
                    return td;
                    break;
                  } else {
                    let promo = false;
                  }
                }

                if (!promo) {
                  td.push(
                    <>
                      {" "}
                      <span style={{ color: "white" }}> ... </span>
                    </>
                  );
                  return td;
                }
              })()}

              {(() => {
                let td = [];
                let promo = false;
                for (let i = 0; i < precios.length; i++) {
                  let item = precios[i];

                  if (item.titulo === titulo1) {
                    promo = true;
                    td.push(
                      <>
                        <span className={styles.tituloazul2Small}>
                          ${item.precio}
                        </span>
                      </>
                    );
                    return td;
                    break;
                  } else {
                    let promo = false;
                  }
                }

                if (!promo) {
                  td.push(
                    <>
                      <span className={styles.tituloazul2Small}>
                        ${precio1}
                      </span>
                      <span className={styles.tituloazul3Small}>/mes</span>
                    </>
                  );
                  return td;
                }
              })()}
            </Col>
          </Row>
          <Row className={styles["textoSmall"]}>
            <ul>{handleDescriptionDots(descripcion1)}</ul>
          </Row>

          {(titulo1 as string).toLowerCase().includes("disney+") ||
          (titulo1 as string).toLowerCase().includes("vix") ? null : (
            <>
              <Row>
                <Col
                  style={{ paddingLeft: "4vw", marginTop: "1vw" }}
                  className={styles["tituloMargin"]}
                >
                  <span className={styles["tituloazulSmall"]}>
                    Selecciona tu TV
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <p className={styles["title"]}>
                    Elige el equipo en el que desfrutarás de los canales
                    seleccionados
                  </p>
                </Col>
              </Row>
              {tarjetas != null && tarjetas.length > 0 ? (
                <Row>
                  <Col>
                    <Form.Label
                      style={{ paddingLeft: "0vw" }}
                      className={styles["textoSmall"]}
                    >
                      Tarjeta inteligente
                    </Form.Label>
                    <Form.Select
                      aria-label="Default select example"
                      className={styles.selectSmall}
                      onChange={obtieneTarjeta}
                    >
                      <option value="0">Selecciona tarjeta</option>
                      {tarjetas.map((tarjeta: any, index: number) => {
                        return (
                          <option
                            key={index}
                            value={tarjeta.TarjetaInteligente}
                          >
                            {tarjeta.TarjetaInteligente}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Col>
                </Row>
              ) : (
                <></>
              )}
            </>
          )}

          {((titulo1 as string).toLowerCase().includes("disney+") ||
            (titulo1 as string).toLowerCase().includes("vix") ||
            (titulo1 as string).toLowerCase().includes("max") ||
            (titulo1 as string).toLowerCase().includes("universal")) && (
            <Row style={{ marginBlock: "1rem" }}>
              <Col style={{}}>
                <Form style={{ maxWidth: "fit-content", marginInline: "auto" }}>
                  <Form.Check // prettier-ignore
                    type="switch"
                    id="Check Terminos y Condiciones"
                    label={
                      <a
                        className={styles["linkText"]}
                        href="https://sky.com.mx/terminos"
                        target="_blank"
                        rel="noreferrer"
                      >
                        He leído y acepto los{" "}
                        <span
                          className={styles["linkFont"]}
                          style={{ textAlign: "center" }}
                        >
                          Términos y condiciones
                        </span>
                      </a>
                    }
                    onChange={handleAcceptedDisneyTerms}
                  />
                </Form>
              </Col>
            </Row>
          )}

          <Row className={styles["centrarSmall"]}>
            <Col className={styles["buttonContainer"]}>
              <Button
                variant="primary"
                className={styles["botonazulSmall"]}
                onClick={() => {
                  doValidaciones();
                }}
              >
                Contratar
              </Button>
            </Col>
            <Col className={styles["buttonContainer"]}>
              {
                <Button
                  variant="primary"
                  className={styles["botonCancelarSmall"]}
                  onClick={(event) => {
                    muestra1(true);
                  }}
                >
                  Cancelar
                </Button>
              }
            </Col>
          </Row>
        </Container>
      </div>

      <Modal
        show={showModalTerminosCondiciones}
        onHide={handleCloseModalTerminosCondiciones}
        size="lg"
        centered
        className={styles["modalSize"]}
      >
        <Modal.Header
          className={styles["modalHeader"]}
          closeButton
        ></Modal.Header>
        <Modal.Header
          className="d-lg-none d-xl-none"
          style={{ borderBottom: "none" }}
        ></Modal.Header>
        <Modal.Body className={styles.contenedorModal}>
          <Container>
            <Row className={styles["alignCenterCenterColumn"]}>
              <Col>
                <h2 className={styles.titulo}>Términos y condiciones</h2>
              </Col>
            </Row>

            <Row className={styles["alignCenterCenterColumn"]}>
              <Col>
                <p className={styles.descripcion}>
                  {" "}
                  Al aceptar la contratación del Servicio SKY on-line (en
                  línea), estoy de acuerdo y acepto los términos y condiciones
                  del contrato de prestación de servicios, arrendamiento y
                  comodato (en adelante el contrato) mismo que se encuentra
                  registrado y ha sido aprobado por el Instituto Federal de
                  Telecomunicaciones y la Procuraduría Federal del Consumidor,
                  el cual he leído y describe los términos y condiciones de
                  contratación, para mayor referencia y futuras consultas se
                  encuentra disponible en todo momento en la página web:
                  www.sky.com.mx, asimismo al aceptar la contratación on-line,
                  SKY se obliga a entregarme una copia de mi contrato al momento
                  de realizar la instalación respectiva de todos los componentes
                  y equipos necesario para la prestación del servicio en mi
                  domicilio.
                </p>
              </Col>
            </Row>

            <Row className={styles["alignCenterCenterColumn"]}>
              <Col md={{ span: 3 }}>
                <Button
                  className={styles.botonModalDetalles}
                  onClick={(event) => {
                    handleShowModalQuieresContratar();
                    handleCloseModalTerminosCondiciones();
                  }}
                >
                  Aceptar
                </Button>
              </Col>
            </Row>

            <Row className={styles["alignCenterCenterColumn"]}>
              <Col md={{ span: 3 }}>
                <Button
                  className={styles.botonCancelarSmall}
                  onClick={(event) => {
                    handleCloseModalTerminosCondiciones();
                  }}
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>

      <Modal
        show={showModalTerminosCondicionesDisney}
        onHide={handleCloseModalTerminosCondicionesDisney}
        size="lg"
        centered
        className={styles["modalSize"]}
      >
        <Modal.Header
          className={styles["modalHeader"]}
          closeButton
        ></Modal.Header>
        <Modal.Header
          className="d-lg-none d-xl-none"
          style={{ borderBottom: "none" }}
        ></Modal.Header>
        <Modal.Body className={styles.contenedorModal}>
          <Container>
            <Row className={styles["alignCenterCenterColumn"]}>
              <Col>
                <h2 className={styles.titulo}>Términos y condiciones</h2>
              </Col>
            </Row>

            <Row className={styles["alignCenterCenterColumn"]}>
              <Col>
                <p className={styles.descripcion}>
                  {" "}
                  TÉRMINOS Y CONDICIONES DE LA OFERTA COMERCIAL DENOMINADA: “MÁS
                  CONTENIDO” La oferta comercial “Más Contenido” se les denomina
                  a los servicios de video, audio, voz o datos que se transmiten
                  sobre cualquier plataforma de internet, que son provistos por
                  terceros, pero comercializados por SKY (en adelante “OTT”), y
                  que están disponibles para los suscriptores que hayan
                  contratado cualquiera de los servicios que SKY ofrece, como
                  son: Servicio de Televisión y Audio Restringidos (en adelante
                  “STAR”) y Sky+, los cuales, pueden ser contratados por un
                  costo adicional y complementario al de su paquete, con el
                  objeto de que los suscriptores puedan disfrutar de mayor
                  contenido en programación. Los servicios descritos
                  anteriormente, se puede adquirir a través de los canales de
                  venta que SKY tiene disponibles, como lo son: Telemarketing,
                  e-commerce, Servicio al cliente, Sky+, desde las Apps Móviles
                  Sky y Sky+, así como a través de distribuidores autorizados. A
                  continuación, se describen las características de los seis
                  distintos OTT’s que se ofrecerán dentro de la oferta comercial
                  “Más Contenido” para el Servicio de televisión y audio
                  restringidos y/o Sky+: 2. CONTRATACIÓN DISNEY+ Términos y
                  Condiciones del acceso a Disney+ como parte de la oferta de
                  “Más contenido” de Sky. 2.1 Objeto El objeto de estos Términos
                  y Condiciones es describir los alcances de la contratación
                  Disney+ como servicio de contenido adicional al paquete
                  previamente contratado por el suscriptor del servicio STAR y/o
                  Sky+. La aceptación de los presentes Términos y Condiciones es
                  indispensable para el uso de Disney+, como servicio digital de
                  contenido adicional al paquete previamente contratado por el
                  suscriptor del servicio STAR y/o Sky+, incluyendo el
                  tratamiento de los datos personales del cliente que son
                  necesarios para la activación de su Cuenta de Disney+, según
                  como se describe más adelante, por lo que, al hacer uso de su
                  Cuenta conforme a lo descrito en el presente, se entenderá que
                  el cliente ha leído y aceptado el Aviso de Privacidad y los
                  presentes Términos y Condiciones, que se pondrán a su
                  disposición, en todo momento, en la página web{" "}
                  <span>
                    <a
                      className={styles["linkFont"]}
                      href="https://www.sky.com.mx/terminos?tab=avisodeprivacidad"
                    >
                      https://www.sky.com.mx/terminos?tab=avisodeprivacidad
                    </a>
                  </span>
                  .
                </p>
              </Col>
            </Row>

            <Row className={styles["alignCenterCenterColumn"]}>
              <Col md={{ span: 3 }}>
                <Button
                  className={styles.botonModalDetalles}
                  onClick={(event) => {
                    handleShowModalQuieresContratar();
                    handleCloseModalTerminosCondicionesDisney();
                  }}
                >
                  Aceptar
                </Button>
              </Col>
            </Row>

            <Row className={styles["alignCenterCenterColumn"]}>
              <Col md={{ span: 3 }}>
                <Button
                  className={styles.botonCancelarSmall}
                  onClick={(event) => {
                    handleCloseModalTerminosCondicionesDisney();
                  }}
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>

      <Modal
        show={showModalQuieresContratar}
        onHide={handleCloseModalQuieresContratar}
        size="lg"
        centered
        className={styles["modalSize"]}
      >
        <Modal.Header
          className={styles["modalHeader"]}
          closeButton
        ></Modal.Header>
        <Modal.Body className={styles.contenedor}>
          <Container>
            <Row className={styles["alignCenterCenterColumn"]}>
              <Col>
                <h2 className={styles.titulo}>
                  {"¿Quieres contratar " + titulo1 + "?"}
                </h2>
              </Col>
            </Row>
            <Row className={styles["alignCenterCenterColumn"]}>
              <Col>
                <p className={styles.descripcionModalConfirmacion}>
                  {"Se agregará un cargo mensual de $" +
                    getFinalePrice() +
                    " a partir de tu próxima factura."}
                </p>
              </Col>
            </Row>

            <Row className={styles["alignCenterCenterColumn"]}>
              <Col md={{ span: 3 }}>
                <Button
                  className={styles.botonazulModal}
                  onClick={(event) => {
                    doContratarCanal();
                    handleCloseModalQuieresContratar();
                  }}
                >
                  Contratar
                </Button>
              </Col>
            </Row>
            <Row className={styles["alignCenterCenterColumn"]}>
              <Col md={{ span: 3 }}>
                <Button
                  className={styles.botonCancelarModal}
                  onClick={(event) => {
                    //handleCloseModalQuieresContratar();
                    muestra1(true);
                  }}
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Canal;
